import services from '../../services'

/** Chave da preferência no servidor: vale para qualquer navegador da pessoa. */
export const PREFERENCIA_GUIA = 'guia-boas-vindas'

const chaveLocal = (usuarioId: unknown) => `np-guia:${usuarioId ?? ''}`

/** A pessoa já viu ou pulou o guia: o servidor diz (qualquer navegador) ou este navegador lembra. */
export function guiaVisto(preferencias: Record<string, string>, usuarioId: unknown): boolean {
  if (preferencias[PREFERENCIA_GUIA] === '1') return true
  try { return localStorage.getItem(chaveLocal(usuarioId)) === '1' } catch { return false }
}

/** Marca como visto neste navegador na hora e no servidor em seguida; se o servidor recusar, o navegador ainda lembra. */
export async function marcarGuiaVisto(usuarioId: unknown): Promise<void> {
  try { localStorage.setItem(chaveLocal(usuarioId), '1') } catch { /* sem armazenamento: só não lembra */ }
  try { await services.api.novoPortalPreferencia(PREFERENCIA_GUIA, '1') } catch { /* o servidor pode não aceitar ainda */ }
}
